import { motion } from 'framer-motion';
import { resumeData } from '../data/resumeData';
import { FaWhatsapp } from 'react-icons/fa';

export default function Contact() {
  const { meta } = resumeData;

  return (
    <section id="contact" className="py-12 bg-black">
      <div className="container mx-auto max-w-5xl">
        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-display font-bold text-center mb-12"
        >
          <span className="bg-gradient-to-r from-green-400 via-primary to-green-400 bg-clip-text text-transparent">
            Get in Touch
          </span>
        </motion.h2>

        {/* All in one row */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          className="flex flex-col md:flex-row justify-center items-center md:space-x-16 space-y-8 md:space-y-0 text-center"
        >
          {/* Email */}
          <div>
            <p className="font-medium mb-2 text-primary text-lg">Email</p>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="https://calendar.app.google/bm6Ay7kwbhB5qJz57"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center text-gray-300 hover:text-white transition-all"
            >
              <span>{meta.email}</span>
            </motion.a>
          </div>

          {/* Social */}
          <div>
            <p className="font-medium mb-2 text-primary text-lg">Social</p>
            <div className="flex justify-center flex-wrap gap-4">
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href={meta.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-gray-900/50 hover:bg-gray-900/80 text-white transition-colors rounded-full font-medium border border-gray-800 hover:border-primary/30"
              >
                LinkedIn
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href={meta.social.portfolio}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-gray-900/50 hover:bg-gray-900/80 text-white transition-colors rounded-full font-medium border border-gray-800 hover:border-primary/30"
              >
                Portfolio
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="https://wa.me/919344063559"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-6 py-3 bg-green-600/80 hover:bg-green-600 text-white transition-colors rounded-full font-medium border border-green-500 hover:border-green-400"
              >
                <FaWhatsapp className="mr-2 text-lg" />
                WhatsApp
              </motion.a>
            </div>
          </div>

          {/* Location */}
          <div>
            <p className="font-medium mb-2 text-primary text-lg">Location</p>
            <p className="text-gray-300">{meta.location}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
